import Markdown from '@portals/shared-frontend/components/Markdown';
import type { NavigationLink } from '@portals/shared-frontend/utils/markdownLinks';
import { extractLinks } from '@portals/shared-frontend/utils/markdownLinks';
import React, { useMemo } from 'react';

import { HeroContent } from '@/components/HeroPage/HeroContent';
import HeroMenu from '@/components/HeroPage/HeroMenu';
import type { NavigationItem } from '@/components/NavigationMenu';
import { NavigationMenu } from '@/components/NavigationMenu';

import HeroMobileMenu from '../HeroPage/HeroMobileMenu';

interface Props {
  content: string;
  loading?: boolean;
}

//Memoize the markdown to avoid rerenders and making it less expensive to scroll.
const MemoizedMarkdown = React.memo(Markdown);

function mapLinksToNavigationItems(links: NavigationLink[]): NavigationItem[] {
  return links.map((link) => ({
    displayName: link.name,
    slug: link.key,
    children: link.children && link.children.length > 0 ? mapLinksToNavigationItems(link.children) : [],
  }));
}

export function HeroPageGuide({ content, loading }: Props) {
  const navigationItems = useMemo(() => {
    const links = extractLinks(content);
    return mapLinksToNavigationItems(links);
  }, [content]);

  return (
    <>
      <HeroMenu noPadding>
        <NavigationMenu items={navigationItems} />
      </HeroMenu>
      <HeroMobileMenu hidden={loading} noPadding>
        <NavigationMenu items={navigationItems} />
      </HeroMobileMenu>
      <HeroContent>
        <MemoizedMarkdown>{content}</MemoizedMarkdown>
      </HeroContent>
    </>
  );
}
